import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";
import { getLeave,getOvertime, updateApproveById } from "services/approval_setting";
import { Util } from "common/util";
import { getMany } from "services/role";
import { Button, Checkbox, Form, SelectInput, Spin,Tabs } from "common/elements";

export default function ApprovalSetting() {
  const [loading, setLoading] = useState(true);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [buttonLoadingOvertime, setButtonLoadingOvertime] = useState(false);
  const [datas, setDatas] = useState([]);
  const util = new Util();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [formOvertime] = Form.useForm();

  const getRoleData = async () => {
    return new Promise ((resolve) => {
      getMany().then((response) => {
        if (response && response.data) {
          resolve(response.data);
        }
      }).catch(error => {
        if (error.response.status === 403) {
          localStorage.removeItem("ACCESS_TOKEN");
          navigate("/signin");
        }
        resolve([]);
      })
    })
   
  };
  const fetchData = async () => {
    const roleData = await getRoleData();
    setDatas(roleData);
    getLeave()
      .then((response) => {
        if(response.data){
          const data = response.data;
          form.setFieldsValue({
            approver: data.approver,
            approve_comment_required: parseInt(data.approve_comment_required),
            reject_comment_required: parseInt(data.reject_comment_required),
            cancel_mandatory_reason: parseInt(data.cancel_mandatory_reason),
            enable_approval_cancellation: parseInt(
              data.enable_approval_cancellation
            ),
            requestor_of_cancellation: data.requestor_of_cancellation,
            enable_reviewer: parseInt(data.enable_reviewer),
            reviewer: data.reviewer,                  
          });
        }     
      }).catch(error => {
        if (error.response.status === 403) {
          localStorage.removeItem("ACCESS_TOKEN");
          navigate("/signin");
        }
      })
      .finally(() => {
        setLoading(false);
      });
      getOvertime()
      .then((response) => {
        if(response.data){
          const data = response.data;
          formOvertime.setFieldsValue({
            approver: data.approver,
            approve_comment_required: parseInt(data.approve_comment_required),
            reject_comment_required: parseInt(data.reject_comment_required),
            requestor_of_cancellation: data.requestor_of_cancellation,
            enable_reviewer: parseInt(data.enable_reviewer),
            reviewer: data.reviewer,                       
          });
        }     
      }).catch(error => {
        if (error.response.status === 403) {
          localStorage.removeItem("ACCESS_TOKEN");
          navigate("/signin");
        }
      })  
      .finally(() => {
        setLoading(false);
      });
  };

  const onFinishOverTime = (values) =>{
    setButtonLoadingOvertime(true)
    values["code"] = "overtime";
    updateApproveById(values)
      .then(() => {
        util.sweetAlertMessage(t("text_success_update"), "success");
      })
      .finally(() => {
        setButtonLoadingOvertime(false);
      });
  }

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  const onFinish = (values) => {
    setButtonLoading(true);
    values["code"] = "leave";
    updateApproveById(values)
      .then(() => {
        util.sweetAlertMessage(t("text_success_update"), "success");
      })
      .finally(() => {
        setButtonLoading(false);
      });
  };
  return (
    <div className="approve">
      {loading ? (
        <Spin
          spinning={loading}
          style={{
            display: "flex",
            justifyContent: "center",
            height: "84vh",
            alignItems: "center",
          }}
        />
      ) : (
       <>
          <div id="title">
            <span>{t("text_approval_setting")}</span>
          </div>

          <Tabs defaultActiveKey="1">
           <Tabs.TabPane tab={t("text_leave")} key="1">
           <Form form={form} onFinish={onFinish}>
          <div id="selectRole">
            <span className="title">{t("text_select_role")}</span>
            <SelectInput
              name="approver"
              placeholder={t("text_select_role_component")}
              valueKey="id"
              dataSource={datas}
            />
          </div>

          <div className="commentRequire">
            <span className="title">{t("text_comment_required")}</span>
            <Form.Item
              name="approve_comment_required"
              valuePropName="checked"
              noStyle
            >
              <Checkbox>{t("text_to_approve_request")}</Checkbox>
            </Form.Item>
            <Form.Item
              name="reject_comment_required"
              valuePropName="checked"
              noStyle
            >
              <Checkbox>{t("text_to_reject_request")}</Checkbox>
            </Form.Item>
          </div>

          <div className="commentRequire">
            <span className="title">{t("text_cancellation_setting")}</span>
            <Form.Item
              name="cancel_mandatory_reason"
              valuePropName="checked"
              noStyle
            >
              <Checkbox>{t("text_reason_mandatory_for_cancellation")}</Checkbox>
            </Form.Item>
            <Form.Item
              name="enable_approval_cancellation"
              valuePropName="checked"
              noStyle
            >
              <Checkbox>{t("text_enable_approvals_for_cancellation")}</Checkbox>
            </Form.Item>
            <div className="inline-select-request">
              <span className="title">{t("text_select_role_request")}</span>
              <SelectInput
                placeholder={t("text_select_role_component")}
                valueKey="id"
                name="requestor_of_cancellation"
                dataSource={datas}
              />
            </div>
          </div>

          <div className="commentRequire">
            <span className="title">{t("text_review_setting")}</span>
            <Form.Item name="enable_reviewer" valuePropName="checked" noStyle>
              <Checkbox>{t("text_enable_review_level")}</Checkbox>
            </Form.Item>
            <div className="inline-select-review">
              <span className="title">{t("text_select_role_review")}</span>
              <SelectInput
                name="reviewer"
                placeholder={t("text_select_role_component")}
                valueKey="id"
                dataSource={datas}
              />
            </div>
          </div>

          <div className="btn-approval">
            <Button type="primary" htmlType="submit" loading={buttonLoading}>
              {t("text_save")}
            </Button>
          </div>
          </Form>
      </Tabs.TabPane>
      <Tabs.TabPane tab={t("text_overtime")} key="2">
      <Form form={formOvertime} onFinish={onFinishOverTime}>
          <div id="selectRole">
            <span className="title">{t("text_select_role")}</span>
            <SelectInput
              name="approver"
              placeholder={t("text_select_role_component")}
              valueKey="id"
              dataSource={datas}
            />
          </div>

          <div className="commentRequire">
            <span className="title">{t("text_comment_required")}</span>
            <Form.Item
              name="approve_comment_required"
              valuePropName="checked"
              noStyle
            >
              <Checkbox>{t("text_to_approve_request")}</Checkbox>
            </Form.Item>
            <Form.Item
              name="reject_comment_required"
              valuePropName="checked"
              noStyle
            >
              <Checkbox>{t("text_to_reject_request")}</Checkbox>
            </Form.Item>
          </div>

          <div className="commentRequire">
            <div className="inline-select-request">
              <span className="title">{t("text_select_role_request")}</span>
              <SelectInput
                placeholder={t("text_select_role_component")}
                valueKey="id"
                name="requestor_of_cancellation"
                dataSource={datas}
              />
            </div>
          </div>

          <div className="commentRequire">
            <span className="title">{t("text_review_setting")}</span>
            <Form.Item name="enable_reviewer" valuePropName="checked" noStyle>
              <Checkbox>{t("text_enable_review_level")}</Checkbox>
            </Form.Item>
            <div className="inline-select-review">
              <span className="title">{t("text_select_role_review")}</span>
              <SelectInput
                name="reviewer"
                placeholder={t("text_select_role_component")}
                valueKey="id"
                dataSource={datas}
              />
            </div>
          </div>

          <div className="btn-approval">
            <Button type="primary" htmlType="submit" loading={buttonLoadingOvertime}>
              {t("text_save")}
            </Button>
          </div>
          </Form>
      </Tabs.TabPane>
      </Tabs>
    </>  
      )}
    </div>
  );
}


